import { Button } from "@/components/ui/button";
import useSurvey from "@/containers/survey/hooks/useSurvey";
import { useFormState } from "react-hook-form";
import { Trash2 } from "lucide-react";

interface RemoveButtonProps {
  index: number;
}

export default function RemoveButton({ index }: RemoveButtonProps) {
  const survey = useSurvey();
  const { isSubmitting, disabled } = useFormState();
  return (
    <Button
      type="button"
      onClick={() => survey.removeQuestion(index)}
      size="icon"
      variant="ghost"
      className="hover:bg-slate-200 shrink-0"
      disabled={isSubmitting || disabled}
      data-testid="remove"
    >
      <Trash2 className="w-5 h-5" />
    </Button>
  );
}
